import { Injectable } from "@angular/core"
import { MatDialog } from "@angular/material/dialog"
import { Actions, createEffect, ofType } from "@ngrx/effects"
import { Store } from "@ngrx/store"
import { finalize, map, switchMap, tap } from "rxjs"
import { GlobalSpinnerActions } from "src/app/shared/ui-kit/global-spinner/actions-types"
import { AgentAction } from "./agent.actions"
import { AgentLeadOfferAcceptedDialogComponent } from "./components/dialogs/agent-lead-offer-accepted-dialog/agent-lead-offer-accepted-dialog.component"
import { AgentLeadOfferRefusedDialogComponent } from "./components/dialogs/agent-lead-offer-refused-dialog/agent-lead-offer-refused-dialog.component"
import { AgentLeadQualifiedDialogComponent } from "./components/dialogs/agent-lead-qualified-dialog/agent-lead-qualified-dialog.component"
import { AgentService } from "./services/agent.service"
import { LobbyErrorHandlerService } from "src/app/core/services/lobby-error-handler.service"
import { LeadActions } from "src/app/core/events/lead.actions"

@Injectable()
export class AgentEffects {

    readonly acceptOffer$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AgentAction.acceptOffer),
            tap(() => this.appStore.dispatch(GlobalSpinnerActions.showGlobalSpinner())),
            switchMap((action) => this.agentService.acceptLeadOffer$(action.leadId).pipe(
                switchMap(() => this.agentService.getLeadInfo$(action.leadId)),
                tap(lead => this.dialog.open(AgentLeadOfferAcceptedDialogComponent, { data: lead })),
                this.errorHandlerService.handleError,
                finalize(() => this.appStore.dispatch(GlobalSpinnerActions.hideGlobalSpinner()))
            )),
        ), { dispatch: false }
    )

    readonly refuseOffer$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AgentAction.refuseOffer),
            tap(() => this.appStore.dispatch(GlobalSpinnerActions.showGlobalSpinner())),
            switchMap((action) => this.agentService.refuseLeadOffer$(action.leadId).pipe(
                switchMap(() => this.agentService.getLeadInfo$(action.leadId)),
                tap(lead => this.dialog.open(AgentLeadOfferRefusedDialogComponent, { data: lead })),
                this.errorHandlerService.handleError,
                finalize(() => this.appStore.dispatch(GlobalSpinnerActions.hideGlobalSpinner()))
            ))
        ), { dispatch: false }
    )

    readonly qualify$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AgentAction.qualifyLead),
            tap(() => this.appStore.dispatch(GlobalSpinnerActions.showGlobalSpinner())),
            switchMap(action => this.agentService.qualifyLead$(action.qualificationRequest[0], action.qualificationRequest[1]).pipe(
                switchMap(() => this.agentService.getLeadInfo$(action.qualificationRequest[0])),
                tap(lead => this.dialog.open(AgentLeadQualifiedDialogComponent, { data: lead })),
                this.errorHandlerService.handleError,
                finalize(() => this.appStore.dispatch(GlobalSpinnerActions.hideGlobalSpinner()))
            ))
        ), { dispatch: false }
    )

    constructor(
        private readonly appStore: Store,
        private readonly actions$: Actions,
        private readonly agentService: AgentService,
        private readonly dialog: MatDialog,
        private readonly errorHandlerService: LobbyErrorHandlerService
    ) { }
}